"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamJoinForm = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _StreamJoinForm = require("./StreamJoinForm.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StreamJoinForm = exports.StreamJoinForm = function StreamJoinForm(_ref) {
  var onSubmit = _ref.onSubmit,
    minHeight = _ref.minHeight,
    title = _ref.title,
    description = _ref.description;
  var spaceReg = /^(\w+\s?)*\s*$/; // ensures that only letters and space is allowed.
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var onNameChange = function onNameChange(event) {
    var value = event.target.value;
    if (spaceReg.test(value)) {
      value = value.replace(/^\s+/g, ''); // remove leading spaces
      value = value.replace(/\s\s+/g, ' '); // replace double spaces with single space
      setName(value);
    }
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var value = name.trim();
    onSubmit(value);
  };
  var buttonDisabled = true;
  if (name.trim()) {
    buttonDisabled = false;
  }
  return /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Wrapper, {
    $minHeight: minHeight
  }, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Title, null, title), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Description, null, description), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledForm, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledLabel, {
    htmlFor: "name"
  }, "Name:"), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledInput, {
    placeholder: "Phillip Jenner",
    value: name,
    onChange: onNameChange,
    "data-testid": "name-input",
    id: "name",
    autoComplete: "name"
  }), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.TosWrapper, null, "By joining you agree to our", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://shoflo.tv/privacy/",
    target: "__blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://shoflo.tv/privacy/",
    target: "__blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"), "."), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledJoinButton, {
    onClick: handleSubmit,
    disabled: buttonDisabled
  }, "Join"))));
};
StreamJoinForm.propTypes = {
  onSubmit: _propTypes.func.isRequired,
  minHeight: _propTypes.string,
  title: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired
};